var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStepCountry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 12C20 11.66 19.96 11.33 19.92 11H19.9381C19.574 8.07992 17.6361 5.64858 15 4.58152V5C15 6.1 14.1 7 13 7H11V9C11 9.55 10.55 10 10 10H8V12H14C14.55 12 15 12.45 15 13V16H16C16.9 16 17.64 16.58 17.9 17.39C19.2 15.97 20 14.08 20 12ZM4.99132 15.8603C6.20012 18.0487 8.40599 19.6082 11 19.93V18C9.9 18 9 17.1 9 16V15L4.21 10.21C4.08 10.79 4 11.38 4 12C4 13.3999 4.35954 14.7157 4.99132 15.8603ZM13.4825 2.10913C18.3023 2.8254 22 6.98088 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C12.5058 2 12.9999 2.03712 13.4825 2.10913Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStepCountry);
export default __webpack_public_path__ + "static/media/icon_step_country.962cfce57687e4521b1b0be6a7cf38e0.svg";
export { ForwardRef as ReactComponent };